import { ReactElement } from 'react';

import { Stack, useTheme } from '@mui/material';

import { IconProps } from './IconBase';

type Props = {
  rotated: boolean;
  children: ReactElement<IconProps>;
};

export function WithRotation(props: Props) {
  const theme = useTheme();

  // The extra span is required to enable hardware acceleration of animation.
  // Applying transform to the SVG element directly doesn't enable it.
  return (
    <Stack
      component="span"
      alignItems="center"
      justifyContent="center"
      sx={{
        willChange: 'transform',
        transform: props.rotated ? 'rotate(180deg)' : 'rotate(0)',
        transition: `transform ${theme.transitions.duration.standard}ms`,
      }}
    >
      {props.children}
    </Stack>
  );
}
